<template>
  <div class="form-box">
	<div class="item-msg-box">
		<div class="item-msg font12px"><TextEllips :text="defaultData.app_name" /></div>
		<div class="item-msg font12px"><TextEllips :text="defaultData.app_id" /></div>
		<div class="item-msg font12px"><TextEllips :text="defaultData.package_name" /></div>
	</div>
    <el-form
      :model="formData"
      ref="formRef"
      :rules="rules"
      label-width="100px"
      label-position="left"
	  style="flex: 1;width: 0;"
    >
      <div class="item-form">
        <el-form-item label="曝光监测地址：" prop="b_address">
          <el-input placeholder="请输入" v-model.trim="formData.b_address" />
        </el-form-item>
      </div>
      <div class="item-form">
        <el-form-item label="点击监测地址：" prop="c_address">
          <el-input placeholder="请输入" v-model.trim="formData.c_address" />
        </el-form-item>
      </div>
      <div
        class="item-form"
        v-if="'rpk_deep_link' in defaultData"
        :class="'rpk_deep_link' in defaultData ? 'link' : ''"
      >
        <el-form-item label="deeplink：" prop="deeplink">
          <el-input placeholder="请输入" v-model.trim="formData.deeplink" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import TextEllips from "@/components/TextEllips";
import _ from "lodash";
let notify = null;
let notify_ = null;
export default {
  name: "FormItem",
  components: { TextEllips },
  props: {
    defaultData: {
      type: Object,
      default: () => ({}),
    },
    deeplinkValidConfig: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    const validateAddress = (rule, value, callback) => {
      try {
        notify_.close();
      } catch (error) {}
      if (!value) {
        callback()
      } else {
        const test =
          /^(https:\/\/)[a-zA-Z0-9\+&@#\/%|\?=~_\|\{\}\!:,\.\-]*[^\?!:,\.]$/
        if (test.test(value)) {
          callback()
        } else {
          notify_ = this.$notify.error({
            title: "输入监测地址不合法",
            message: `需要以https://开头，并且名称中只能包含英文、数字及+&@#/%?=~_|{}!:,.字符，并且?!:,.字符不能在末尾，不能有空格`,
            duration: 0,
          })
          callback(new Error("输入地址不合法"))
        }
      }
    };
    
    const validateDeeplink = (rule, value, callback) => {
      try {
        notify.close();
      } catch (error) {}
      if (!value) {
        callback(new Error("此项必填"))
      } else {
        const test = new RegExp(`^(${this.deeplinkValidConfig.join('|')})`)
        if (test.test(value)) {
          callback()
        } else {
          notify = this.$notify.error({
            title: "输入deeplink地址不合法",
            dangerouslyUseHTMLString: true,
            message: `只能以下内容开头${_.map(this.deeplinkValidConfig, (v=>`<p>${v}</p>`)).join('')}`,
            duration: 0,
          })
          callback(new Error(`输入地址不合法`))
        }
      }
    }
    const { click_monitor_url, view_monitor_url, rpk_deep_link } = this.defaultData
    return {
      formData: {
        b_address: view_monitor_url,
        c_address: click_monitor_url,
        deeplink: rpk_deep_link,
      },
      rules: {
        b_address: [{ validator: validateAddress, trigger: "blur" }],
        c_address: [{ validator: validateAddress, trigger: "blur" }],
        deeplink: [
          { required: true, validator: validateDeeplink, trigger: "blur" },
        ],
      },
    }
  },
  methods: {
	async validateFn() {
		const valid = await this.$refs.formRef.validate();
		if(valid) { 
			return {
        package_name: this.defaultData.package_name,
        ...this.formData
      };
		} else {
			return false;
		}
	},
	
  }
}
</script>

<style lang="scss" scoped>
.form-box {
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 0 4px #ccc;
  padding: 6px 16px;
  display: flex;
  .item-msg-box {
	width: 140px;
	margin-right: 10px;
  }
  .item-form {
	position: relative;
	&::before {
        content: "";
        position: absolute;
        top: 8px;
        left: -8px;
        width: 2px;
        height: 50%;
        background: #ccc;
      }
	  &.link {
		&::before {
			background: rgb(233, 0, 0);
		}
    }
  }
  .form-item {
    .item-msg {
      width: 100%;
     
      margin-right: 6px;
      font-size: 12px;
      line-height: 30px;
      
    }
    
  }
}
</style>